import CryptoJS from 'crypto-js';

// Encrypt password before sending to server
export const encryptPassword = (password) => {
  const secretKey = process.env.REACT_APP_ENCRYPTION_KEY || 'admin-secret-key-2025';
  return CryptoJS.AES.encrypt(password, secretKey).toString();
};

// Decrypt password (if needed)
export const decryptPassword = (encryptedPassword) => {
  const secretKey = process.env.REACT_APP_ENCRYPTION_KEY || 'admin-secret-key-2025';
  const bytes = CryptoJS.AES.decrypt(encryptedPassword, secretKey);
  return bytes.toString(CryptoJS.enc.Utf8);
};